import { EventDatesCard } from "../EventInfo";
import { InfoCommunity } from "./InfoCommunity";
import { InfoFAQ } from "./InfoFAQ";
import { InfoPrivacy } from "./InfoPrivacy";
import { InfoRules } from "./InfoRules";
import { InfoWelcome } from "./InfoWelcome";

export interface IRule {
  id: string;
  order: number;
  name: string;
  description: string | null;
}

export const InfoText = () => {
  return (
    <div className="flex flex-col p-5 py-1 gap-2">
      <EventDatesCard />
      <InfoWelcome />
      <InfoRules />
      <InfoFAQ />
      <InfoPrivacy />
      <InfoCommunity />
    </div>
  );
};
